<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card class="md-card-plain">
          <md-card-header data-background-color="green">
            <h4 class="title">Gestionar Fecha</h4>
          </md-card-header>

          <md-card-content>
            <div class="iframe-container">
              <iframe src="https://back.saborgrafico.com.ar/consultar-fecha">
                <p>Your browser does not support iframes.</p>
              </iframe>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
